import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const accountDetailsTabContentOverviewStyles = StyleSheet.create({
	column: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		width: '100%',
	},
	skeletonCard: {
		height: 280,
		width: '100%',
	},
	errorState: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		justifyContent: 'center',
		minHeight: 200,
		textAlign: 'center',
		width: '100%',
	},
});
